import { FormControl, FormGroup } from '@angular/forms';

//密码中必须包含大小写 字母、数字、特殊字符，至少8个字符，最多20个字符；
export function passwordMaxValidator(control: FormControl): any {
  if (!control.value) {
    return true;
  } else {
    const regs = new RegExp('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,20}');
    const valid = regs.test(control.value);
    return valid ? null : { passwordMax: true };
  }
}

//密码中必须包含字母（不区分大小写）、数字、特殊字符，至少8个字符，最多20个字符；
export function passwordMiddleValidator(control: FormControl): any {
  if (!control.value) {
    return true;
  } else {
    const regs = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}');
    const valid = regs.test(control.value);
    return valid ? null : { passwordMiddle: true };
  }
}

//密码中必须包含字母（不区分大小写）、数字，至少8个字符，最多20个字符；
export function passwordMinValidator(control: FormControl): any {
  if (!control.value) {
    return true;
  } else {
    const regs = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{8,20}');;
    const valid = regs.test(control.value);
    return valid ? null : { passwordMin: true };
  }
}

//输入前后空格验证
export function spaceValidator(control: FormControl): any {
  if (!control.value) {
    return true;
  } else {
    const regs = /^(?!\s)(?!.*\s$)/;
    const valid = regs.test(control.value);
    return valid ? null : { space: true };
  }
};


//验证正整数——单一字段
export function numberTimeValidator(control: FormControl): any {
  if (!control.value) {
    return true;
  } else {
    const regs = /^[1-9]\d*$/;
    const valid = regs.test(control.value);
    return valid ? null : { numberTime: true };
  }
}

//验证大于0
export function MaxZeroValidator(control: FormControl): any {
  if (!control.value) {
    return true;
  } else {
    const regs = /^([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])$/;
    const valid = regs.test(control.value);
    return valid ? null : { maxZero: true };
  }
}


// 验证金额数字
export function amountValidator(control: FormControl): any {
  if (!control.value) {
    return true;
  } else {
    const regs = /^([1-9][\d]{0,7}|0)(\.[\d]{1,2})?$/;
    const valid = regs.test(control.value);
    return valid ? null : { amount: true };
  }
}

// 验证电话号码
export function phoneValidator(control: FormControl): any {
  if (!control.value) {
    return true;
  } else {
    const regs = /^(?:(?:\+|00)86)?1[3-9]\d{9}$|^0\d{2,3}-?\d{7,8}$/;
    const valid = regs.test(control.value);
    return valid ? null : { phone: true };
  }
}

//验证身份证
export function IDcardValidator(control: FormControl): any {
  if (!control.value) {
    return true;
  } else {
    // const regs = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    const regs = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    const valid = regs.test(control.value);
    return valid ? null : { IDcard: true };
  }
}
//验证只能是英文和数字
export function enandnumValidator(control: FormControl): any {
  if (!control.value) {
    return true;
  } else {
    const regs = /^[0-9a-zA-Z]*$/;
    const valid = regs.test(control.value);
    return valid ? null : { enandnum: true };
  }
}
//验证只能为英文
export function enValidator(control: FormControl): any {
  if (!control.value) {
    return true;
  } else {
    const regs = /^[a-zA-Z]*$/;
    const valid = regs.test(control.value);
    return valid ? null : { en: true };
  }
}
//验证只能为汉字
export function chineseValidator(control: FormControl): any {
  if (!control.value) {
    return true;
  } else {
    const regs = /^[\u0391-\uFFE5]+$/;
    const valid = regs.test(control.value);
    return valid ? null : { chinese: true };
  }
}
//验证邮箱
export function emailValidator(control: FormControl): any {
  if (!control.value) {
    return true;
  } else {
    const regs = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
    const valid = regs.test(control.value);
    return valid ? null : { email: true };
  }
}
//  验证密码是否相同
export function ConfirmationValidator(params, form) {
  return (control: FormControl, controls: FormGroup): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (control.value !== form().controls[params.password].value) {
      return { confirm: true };
    }
    return {};
  }
};
export function DeviceconfigValidator(configSaveName): Boolean {
  let str = localStorage.getItem(configSaveName) || null
  if (str == null) {
    return false;
  }
  return true;
};
